import React from "react";
import _ from "lodash";
import { Link } from "react-router-dom";
import { List, Map } from "immutable";
import { components } from "griddle-react";

import { Playlist } from "../../models";

interface Props {
    playlists: Playlist[];
}

export const PlaylistsList = ({ playlists }: Props) => {
    const albumTitles: Array<JSX.Element | string> = [];
    for (const album of playlists) {
        const albumUrl = album.getViewUrl();
        if (albumUrl != null) {
            albumTitles.push(<Link key={album.id} to={albumUrl}>{album.name}</Link>);
        }
        else {
            albumTitles.push(album.name);
        }
    }
    return (
        <span className="playlists-list">
            {_.reduce(albumTitles,
                (result, album) => result.length === 0 ? [album] : [...result, ", ", album],
            [])}
        </span>
    );
};

export const CellPlaylistsList = ({ value }: components.CellProps) => {
    let playlists: Playlist[] = value;
    if (!Array.isArray(value)) {
        const list = value as List<Map<string, any>>;
        playlists = _.map(list.toArray(), (map) => new Playlist(map.toObject()));
    }
    return <PlaylistsList playlists={playlists} />;
};
